// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__2UGD3","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3JkxL"};